<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row class="hidden-sm-and-up">
      <el-col>
        <div class="mineNav-left">
          <ul class="mineNav">
            <li class="active" @click="toPath('/mine')">
              {{ $t("exhibitor.personal") }}
            </li>
            <li @click="show(0)">
              <p>
                {{ $t("exhibitor.collect") }}
                <i class="el-icon-arrow-down"></i>
              </p>
              <ul class="minesubnav" v-if="isSHowSub">
                <li @click.stop="collectMChange(0)">
                  {{ $t("exhibitor.product") }}
                </li>
                <li @click.stop="collectChange(1)">
                  {{ $t("exhibitor.enterprise") }}
                </li>
                <li @click.stop="collectMChange(2)">
                  {{ $t("navMenu.active") }}
                </li>
              </ul>
            </li>
            <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} 
                  <i class="el-icon-arrow-down"></i>
                </p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandMChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandMChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandMChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
            </li>-->
            <!-- <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li> -->
            <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
          </ul>
        </div>
      </el-col>
    </el-row>
    <div class="tips">{{ $t("business.mineText") }}</div>
    <el-row class="exmain">
      <el-col :xs="xsNumLeft" :sm="xsNumLeft" :md="3" :lg="3" :xl="4"></el-col>
      <el-col
        :xs="xsNumLeftNav"
        :sm="xsNumLeftNav"
        :md="5"
        :lg="2"
        :xl="2"
        class="hidden-sm-and-down"
      >
        <div class="mineNav-left">
          <ul class="mineNav">
            <li @click="toPath('/mine')" class="active">
              {{ $t("exhibitor.personal") }}
            </li>
            <li @click="show(0)">
              <p>
                {{ $t("exhibitor.collect") }}
                <i class="el-icon-arrow-right"></i>
              </p>
              <ul class="minesubnav" v-if="isSHowSub">
                <li @click.stop="collectChange(0)">
                  {{ $t("exhibitor.product") }}
                </li>
                <li @click.stop="collectChange(1)">
                  {{ $t("exhibitor.enterprise") }}
                </li>
                <li @click.stop="collectChange(2)">
                  {{ $t("navMenu.active") }}
                </li>
              </ul>
            </li>
            <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
            </li>-->
            <!-- <li @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li> -->
            <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
          </ul>
        </div>
      </el-col>
      <el-col :xs="xsNum" :sm="xsNum" :md="14" :lg="14" :xl="10">
        <div class="main-right" :style="{ minHeight: height }">
          <div class="data-edit-wrap">
            <!-- <div class="data-edit-userinfo">
                        <img v-if="userInfo.avatar.length > 0" class="data-avatar" :src="$imgUrl + userInfo.avatar" alt="">
                        <img v-else class="data-avatar" src="../../../assets/logo.jpg" alt="">
                        <div class="data-text">
                            <p class="data-nickname">{{userInfo.nickname}} <span>{{userInfo.dutiesName}}</span></p>
                            <p>{{userInfo.company_Name}}</p>
                            <p>{{userInfo.mobile}}</p>
                        </div>
            </div>-->
            <ul v-if="edit" class="data-edit-list">
              <li>
                <p class="edit-label Required">{{ $t("business.sex") }}</p>
                <p v-if="userInfo.sex == 0">{{ $t("business.man") }}</p>
                <p v-if="userInfo.sex == 1">{{ $t("business.woman") }}</p>
                <p v-if="userInfo.sex == 2">{{ $t("business.Mis") }}</p>
              </li>
              <li>
                <p class="edit-label Required">{{ $t("business.nickname") }}</p>
                <p>{{ userInfo.nickname }}</p>
              </li>

              <li>
                <p class="edit-label">{{ $t("business.mobile") }}</p>
                <p>{{ userInfo.mobile }}</p>
              </li>
              <li>
                <p class="edit-label Required">{{ $t("business.email") }}</p>
                <p>{{ userInfo.email }}</p>
              </li>
              <li>
                <p class="edit-label Required">
                  {{ $t("business.companyName") }}
                </p>
                <p>{{ userInfo.companyName }}</p>
              </li>
              <li>
                <p class="edit-label Required">{{ $t("business.country") }}</p>
                <p>{{ userInfo.country }}</p>
              </li>
              <li>
                <p class="edit-label">{{ $t("business.city") }}</p>
                <p>{{ userInfo.city }}</p>
              </li>
              <li>
                <p class="edit-label Required">
                  {{ $t("business.businessNature") }}
                </p>
                <p v-if="langSet == 'zh' || userInfo.en_industryName == null">
                  {{ userInfo.industryName }}
                </p>
                <p v-if="langSet == 'en' && userInfo.en_industryName != null">
                  {{ userInfo.en_industryName }}
                </p>
              </li>
              <!-- <li>
                            <p class="edit-label">{{$t('business.deportment')}}</p>
                            <p v-if="langSet == 'zh' || userInfo.en_departmentName == null">{{userInfo.departmentName}}</p>
                            <p v-if="langSet == 'en' && userInfo.en_departmentName != null" >{{userInfo.en_departmentName}}</p>
                        </li>
                        <li>
                            <p class="edit-label">{{$t('business.jobLevel')}}</p>
                            <p v-if="langSet == 'zh' || userInfo.en_dutiesName == null">{{userInfo.dutiesName}}</p>
                            <p v-if="langSet == 'en' && userInfo.en_dutiesName != null" >{{userInfo.en_dutiesName}}</p>
              </li>-->
            </ul>
            <ul v-else class="data-edit-list">
              <li>
                <p class="edit-label Required">{{ $t("business.sex") }}</p>
                <el-radio class="labelRadio" v-model="sex" label="0">{{
                  $t("business.man")
                }}</el-radio>
                <el-radio class="labelRadio" v-model="sex" label="1">{{
                  $t("business.woman")
                }}</el-radio>
                <el-radio class="labelRadio" v-model="sex" label="2">{{
                  $t("business.Mis")
                }}</el-radio>
              </li>
              <li>
                <p class="edit-label Required">{{ $t("business.nickname") }}</p>
                <p>
                  <el-input
                    v-model="nickname"
                    :placeholder="rule.rule_nickname"
                  ></el-input>
                </p>
              </li>
              <li>
                <p class="edit-label">{{ $t("business.mobile") }}</p>
                <p>
                  <el-input
                    v-model="mobile"
                    :placeholder="rule.rule_mobile"
                    type="number"
                    :disabled="disable_dis.mobile_dis"
                    oninput="if(value.length>=30)value=value.slice(0,30)"
                  ></el-input>
                </p>
              </li>
              <li>
                <p class="edit-label Required">{{ $t("business.email") }}</p>
                <p>
                  <el-input
                    v-model="email"
                    :placeholder="email"
                    :disabled="disable_dis.email_dis"
                  ></el-input>
                </p>
              </li>
              <li>
                <p class="edit-label Required">
                  {{ $t("business.companyName") }}
                </p>
                <p>
                  <el-input
                    v-model="companyName"
                    :placeholder="rule.rule_companyName"
                  ></el-input>
                </p>
              </li>
              <li>
                <p class="edit-label Required">{{ $t("business.country") }}</p>
                <p>
                  <el-input
                    v-model="country"
                    :placeholder="rule.rule_country"
                  ></el-input>
                </p>
              </li>
              <li>
                <p class="edit-label">{{ $t("business.city") }}</p>
                <p>
                  <el-input
                    v-model="city"
                    :placeholder="rule.rule_city"
                  ></el-input>
                </p>
              </li>
              <li>
                <p class="edit-label Required">
                  {{ $t("business.businessNature") }}
                </p>
                <p>
                  <el-select
                    v-if="langSet == 'zh'"
                    v-model="industryName"
                    :placeholder="industryName"
                    @change="currentSelIndustry"
                  >
                    <el-option
                      v-for="item in industryOptions"
                      :key="item.linkageid"
                      :label="item.id"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="langSet == 'en'"
                    v-model="industryName"
                    :placeholder="industryName"
                    @change="currentSelIndustry"
                  >
                    <el-option
                      v-for="item in industryOptions"
                      :key="item.linkageid"
                      :label="item.id"
                      :value="item.description"
                    ></el-option>
                  </el-select>
                </p>
              </li>
              <!-- <li>
                <p class="edit-label Required">{{$t('business.deportment')}}</p>
                <p>
                  <el-select
                    v-if="langSet == 'zh'"
                    v-model="departmentName"
                    :placeholder="departmentName"
                    @change="currentSelDepartment"
                  >
                    <el-option
                      v-for="item in departmentOptions"
                      :key="item.linkageid"
                      :label="item.id"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="langSet == 'en'"
                    v-model="departmentName"
                    :placeholder="departmentName"
                    @change="currentSelDepartment"
                  >
                    <el-option
                      v-for="item in departmentOptions"
                      :key="item.linkageid"
                      :label="item.id"
                      :value="item.description"
                    ></el-option>
                  </el-select>
                </p>
              </li>
              <li>
                <p class="edit-label Required">{{$t('business.jobLevel')}}</p>
                <p>
                  <el-select
                    v-if="langSet == 'zh'"
                    v-model="dutiesName"
                    :placeholder="dutiesName"
                    @change="currentSelDuties"
                  >
                    <el-option
                      v-for="item in dutiesOptions"
                      :key="item.linkageid"
                      :label="item.id"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-if="langSet == 'en'"
                    v-model="dutiesName"
                    :placeholder="dutiesName"
                    @change="currentSelDuties"
                  >
                    <el-option
                      v-for="item in dutiesOptions"
                      :key="item.linkageid"
                      :label="item.id"
                      :value="item.description"
                    ></el-option>
                  </el-select>
                </p>
              </li> -->
            </ul>
            <div v-if="edit" class="edit-btn 1" @click="editData">
              {{ $t("business.edit") }}
            </div>
            <div v-else class="edit-btn 2" @click="save">
              {{ $t("business.save") }}
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../../components/top.vue";
import bottom from "../../../components/bottom.vue";
import { getUser, getActivityclass, updMemberinfo } from "@/api/api";
export default {
  components: { top, bottom },
  name: "mine",
  data() {
    return {
      radio: "1",
      isSHowSub: false,
      isSHowSubDemand: false,
      userInfo: {
        avatar: "",
        en_industryName: "",
        en_departmentName: "",
        en_dutiesName: "",
      },
      edit: true,
      nickname: "",
      mobile: "",
      email: "",
      companyName: "",
      country: "",
      city: "",
      sex: "0",
      industryName: "",
      industryId: "",
      industryOptions: [],
      departmentName: "",
      departmentId: "",
      departmentOptions: [],
      dutiesName: "",
      dutiesId: "",
      dutiesOptions: [],
      height: "",
      langSet: "",
      xsNumLeft: 1,
      xsNumLeftNav: 4,
      xsNum: 18,
      rule: {
        // 绑定的placeholder的值
        rule_nickname: "",
        rule_mobile: "",
        rule_companyName: "",
        rule_country: "",
        rule_city: "",
      },
      disable_dis: {
        email_dis: false,
        mobile_dis: false,
      },
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "zh";
    this.memberid = localStorage.getItem("memberid");
    this.getData();
    this.setHeight();
    if (this._isMobile()) {
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 0;
      this.xsNum = 22;
    } else {
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 4;
      this.xsNum = 18;
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    collectMChange(index) {
      if (index == 0) {
        this.$router.push({
          name: "myproduct",
        });
      } else if (index == 1) {
        this.$router.push({
          name: "mycompany",
        });
      } else if (index == 2) {
        this.$router.push({
          name: "myactive",
        });
      }
      this.isSHowSub = !this.isSHowSub;
    },
    demandMChange(index) {
      if (index == 0) {
        this.$router.push({
          name: "demandissue",
        });
      } else if (index == 1) {
        this.$router.push({
          name: "myresponse",
        });
      } else if (index == 2) {
        this.$router.push({
          name: "mymessage",
        });
      }
      this.isSHowSubDemand = !this.isSHowSubDemand;
    },
    setHeight() {
      this.height = window.innerHeight - 175 + "px";
    },
    getClass(data) {
      var dataObj = this.$qs.parse(data);
      getActivityclass(data)
        .then((res) => {
          if (res.status == 200) {
            if (dataObj.keyid == "3588") {
              this.industryOptions = res.data;
              //console.log(this.industryOptions)
            } else if (dataObj.keyid == "3589") {
              this.departmentOptions = res.data;
            } else if (dataObj.keyid == "3590") {
              this.dutiesOptions = res.data;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editData() {
      this.edit = false;
      if (!this.edit) {
        let data = this.$qs.stringify({
          keyid: "3588",
        });
        this.getClass(data);
        let departmentData = this.$qs.stringify({
          keyid: "3589",
        });
        this.getClass(departmentData);
        let dutiesData = this.$qs.stringify({
          keyid: "3590",
        });
        this.getClass(dutiesData);
      }
    },
    toPath(path) {
      this.$router.push({ path });
    },
    show(id) {
      if (id == 0) {
        this.isSHowSub = !this.isSHowSub;
      } else {
        this.isSHowSubDemand = !this.isSHowSubDemand;
      }
    },
    collectChange(index) {
      //console.log(index)
      if (index == 0) {
        this.$router.push({
          name: "myproduct",
        });
      } else if (index == 1) {
        this.$router.push({
          name: "mycompany",
        });
      } else if (index == 2) {
        this.$router.push({
          name: "myactive",
        });
      }
    },
    demandChange(index) {
      if (index == 0) {
        this.$router.push({
          name: "demandissue",
        });
      } else if (index == 1) {
        this.$router.push({
          name: "myresponse",
        });
      } else if (index == 2) {
        this.$router.push({
          name: "mymessage",
        });
      }
    },
    getData() {
      let data = this.$qs.stringify({
        memberid: this.memberid,
        uuid: this.$uuid,
      });
      getUser(data)
        .then((res) => {
          console.log(res);
          //console.log(res.data.rst)
          if (res.data.errno == 0) {
            this.userInfo = res.data.rst;
            this.nickname = res.data.rst.nickname;
            this.mobile = res.data.rst.mobile;
            this.email = res.data.rst.email;
            this.companyName = res.data.rst.companyName;
            this.country = res.data.rst.country;
            this.city = res.data.rst.city;
            this.sex = res.data.rst.sex;
            this.industryId = res.data.rst.industry;
            this.departmentId = res.data.rst.department;
            this.dutiesId = res.data.rst.duties;

            if (this.mobile && !this.email) {
              this.disable_dis = {
                email_dis: false,
                mobile_dis: true,
              };
            } else if (!this.mobile && this.email) {
              this.disable_dis = {
                email_dis: true,
                mobile_dis: false,
              };
            }

            if (this.langSet == "zh") {
              // this.nickname = '请填写姓名';
              this.rule.rule_nickname = "请填写姓名";
            } else if (this.langSet == "en") {
              // this.nickname = 'Please fill in your name';
              this.rule.rule_nickname = "Please fill in your name";
            }

            // if (this.langSet == "zh") {
            //   // this.nickname = '请填写姓名';
            //   this.rule.rule_mobile = "请填写手机号";
            // } else if (this.langSet == "en") {
            //   // this.nickname = 'Please fill in your name';
            //   this.rule.rule_mobile = "Please fill in your mobile";
            // }

            if (this.langSet == "zh") {
              this.rule.rule_country = "请填写国家";
            } else if (this.langSet == "en") {
              this.rule.rule_country = "Please fill in your country";
            }
            // if (this.langSet == "zh") {
            //   this.rule.rule_city = "请填写城市";
            // } else if (this.langSet == "en") {
            //   this.rule.rule_city = "Please fill in your city";
            // }

            if (this.langSet == "zh") {
              this.rule.rule_mobile = "请填写手机号";
            } else if (this.langSet == "en") {
              this.rule.rule_mobile = "Please fill in your mobile";
            }
            if (this.langSet == "zh") {
              this.rule.rule_companyName = "请填写公司名称";
            } else if (this.langSet == "en") {
              this.rule.rule_companyName = "Please fill in your company Name";
            }
            if (this.langSet == "zh" || res.data.rst.en_industryName == null) {
              this.industryName = res.data.rst.industryName;
            } else if (
              this.langSet == "en" &&
              res.data.rst.en_industryName != null
            ) {
              this.industryName = res.data.rst.en_industryName;
            }
            if (
              this.langSet == "zh" ||
              res.data.rst.en_departmentName == null
            ) {
              this.departmentName = res.data.rst.departmentName;
            } else if (
              this.langSet == "en" &&
              res.data.rst.en_departmentName != null
            ) {
              this.departmentName = res.data.rst.en_departmentName;
            }
            if (this.langSet == "zh" || res.data.rst.en_dutiesName == null) {
              this.dutiesName = res.data.rst.dutiesName;
            } else if (
              this.langSet == "en" &&
              res.data.rst.en_dutiesName != null
            ) {
              this.dutiesName = res.data.rst.en_dutiesName;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    currentSelIndustry(event) {
      console.log(event);
      let obj = {};
      obj = this.industryOptions.find((item) => {
        if (this.langSet == "zh") {
          return item.name === event;
        } else {
          return item.description === event;
        }
      });
      console.log(obj);
      this.industryId = obj.linkageid;
    },
    currentSelDepartment(event) {
      let obj = {};
      obj = this.departmentOptions.find((item) => {
        if (this.langSet == "zh") {
          return item.name === event;
        } else {
          return item.description === event;
        }
      });
      //console.log(obj)
      this.departmentId = obj.linkageid;
    },
    currentSelDuties(event) {
      let obj = {};
      obj = this.dutiesOptions.find((item) => {
        if (this.langSet == "zh") {
          return item.name === event;
        } else {
          return item.description === event;
        }
      });
      //console.log(obj)
      this.dutiesId = obj.linkageid;
    },
    save() {
      var iserr = false;
      var langSet = this.langSet;
      //  var rex_mobile = new RegExp("^[0-9]*$")
      var errtext = "";
      //  console.log('正则',rex_mobile.test(this.mobile));
      if (!this.nickname) {
        errtext = langSet == "zh" ? "请填名字" : "Please fill in your name";
        iserr = true;
      }
      // else if(!this.mobile){
      //   errtext=langSet=='zh'?'请填写手机号':'Please fill in your mobile'
      //   iserr = true
      // }
      else if (!this.companyName) {
        errtext =
          langSet == "zh"
            ? "请填写公司名称"
            : "Please fill in your company Name";
        iserr = true;
      } else if (!this.country) {
        errtext =
          langSet == "zh" ? "请填写国家" : "Please fill in your country";
        iserr = true;
      }
      //  else if (!this.city) {
      //   errtext = langSet == "zh" ? "请填写城市" : "Please fill in your city";
      //   iserr = true;
      // }
      else if (!this.industryName) {
        errtext =
          langSet == "zh"
            ? "请选择行业属性"
            : "Please select your Business Nature";
        iserr = true;
      }
      // else if (!this.departmentName) {
      //   errtext =
      //     langSet == "zh" ? "请选择部门属性" : "Please select your department";
      //   iserr = true;
      // } else if (!this.dutiesName) {
      //   errtext =
      //     langSet == "zh" ? "请选择职务级别" : "Please select your Job Level";
      //   iserr = true;
      // }
      console.log(this.industryName, this.departmentName, this.dutiesName);

      // const regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      const regEmail =
        /^[a-zA-Z0-9_-](([a-zA-Z0-9_-]|(\.[a-zA-Z0-9_-])){0,30})@[a-zA-Z0-9_-]+(\.[a-zA-Z]+){1,2}$/;

      let isEmail = regEmail.test(this.email);
      // let isMobile = regMobile.test(this.username);
      console.log(isEmail);
      if (!isEmail) {
        var mes = "请正确输入邮箱地址";
        if (this.langSet == "en") {
          mes = "Please enter the correct email address";
        }
        this.$alert(mes, {
          confirmButtonText: "确定/OK",
          center: true,
          callback: (action) => {
            this.$message({
              type: "error",
              message: mes,
            });
          },
        });
        // this.$message({
        //   message: mes,
        //   center: true,
        // });
        return;
      }

      if (iserr) {
        // this.$message.error(errtext);
        this.$alert(errtext, {
          confirmButtonText: "确定/OK",
          center: true,
          callback: (action) => {
            this.$message({
              type: "error",
              message: errtext,
            });
          },
        });
        return;
      }
      console.log(this.industryId, this.departmentId, this.dutiesId);
      let data = this.$qs.stringify({
        memberid: this.memberid,
        email: this.email,
        mobile: this.mobile,
        nickname: this.nickname,
        companyName: this.companyName,
        industry: this.industryId,
        department: this.departmentId,
        duties: this.dutiesId,
        sex: this.sex,
        country: this.country,
        city: this.city,
      });
      updMemberinfo(data)
        .then((res) => {
          console.log(res);
          const self = this;
          if (res.data.errno == 0) {
            //this.edit = true;
            // location.reload();
          
            // this.$router.push({name: "pair"});
            localStorage.setItem('improve',false);
               
               localStorage.setItem('finishDataEdit',true)
                this.$router.push({path: "/pair"});
          
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-radio__label {
  font-size: 18px;
}
.el-radio__input.is-checked + .el-radio__label {
  color: #cac28a !important;
  font-size: 20px !important;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #cac28a;
  background: #cac28a;
}
.labelRadio {
  line-height: 28px;
}
.tips {
  font-size: 21px;
  color: red;
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-weight: 600;
}
.exmain .main-right {
  box-sizing: border-box;
}
.main {
  padding-top: 40px;
  padding-left: 184px;
}
.mineNav > li {
  font-size: 20px;
  line-height: 28px;
  color: #000;
  margin-bottom: 24px;
  cursor: pointer;
  width: 100px;
  text-align: center;
}
.mineNav > li.active {
  color: #cac28a;
}
.mineNav > li p {
  position: relative;
}
.mineNav > li p i {
  position: absolute;
  top: 5px;
}
.mineNav > li .minesubnav {
  color: #666;
  font-size: 18px;
  line-height: 25px;
  padding-bottom: 13px;
  text-align: center;
}
.mineNav > li .minesubnav .active {
  color: #cac28a;
}

.data-edit-wrap {
  width: 50%;
  margin: 0 auto;
}
.data-edit-wrap .data-edit-userinfo {
  display: flex;
  width: 100%;
  background: rgba(214, 204, 198, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  border: 2px solid rgba(151, 151, 151, 1);
  padding: 20px 15px;
  box-sizing: border-box;
  align-items: center;
}
.data-edit-wrap .data-edit-userinfo .data-avatar {
  width: 80px;
  height: 80px;
  border: 0px solid rgba(255, 255, 255, 1);
  margin-right: 11px;
  border-radius: 50%;
}
.data-edit-wrap .data-edit-userinfo .data-text {
  font-size: 16px;
  line-height: 22px;
  color: #666;
}
.data-edit-wrap .data-edit-userinfo .data-text .data-nickname {
  font-size: 20px;
  line-height: 28px;
  color: #000;
}
.data-edit-wrap .data-text .data-nickname span {
  font-size: 14px;
  color: #666;
}
.data-edit-list li {
  display: flex;
  margin-top: 34px;
  line-height: 28px;
  font-size: 20px;
  color: #000;
}
.data-edit-list li p {
  width: 70%;
}
.data-edit-list li p.edit-label {
  width: 100px;
  color: #999;
  margin-right: 33px;
}
.Required::after {
  content: "*";
  color: red;
}
.edit-btn {
  width: 199px;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background: linear-gradient(180deg, rgba(236, 172, 167, 1) 0%, #cac28a 100%);
  border-radius: 3px;
  border: 1px solid rgba(244, 146, 141, 1);
  color: #fff;
  font-size: 25px;
  margin: 60px auto 0;
  cursor: pointer;
}
.data-edit-list li p .el-input__inner {
  border: 0 none;
  border-bottom: 1px solid #999;
  border-radius: 0;
  padding: 0;
  height: 30px;
  line-height: 30px;
  color: #000;
  font-size: 20px;
}
.data-edit-list .el-select {
  width: 100%;
}
.data-edit-list .el-select .el-input__inner:focus,
.data-edit-list .el-select .el-input.is-focus .el-input__inner {
  border-color: #999;
}
.data-edit-list li .el-input__inner::placeholder {
  color: #000;
}
.mineNav > li.inbox {
  background: rgba(224, 153, 149, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 18px;
}
@media only screen and (max-width: 767px) {
  .el-message-box--center {
    position: relative;
    top: 40%;
  }
  .labelRadio {
    line-height: 0.3rem;
  }
  .mineNav {
    padding: 0 0.2rem;
    display: flex;
    margin-top: 0.2rem;
    li.inbox {
      font-size: 11px;
    }
    li {
      font-size: 11px;
      flex: 1;
      position: relative;
      margin-bottom: 0;
      p i {
        top: 0.18rem;
      }
      .minesubnav {
        font-size: 11px;
        line-height: 0.25rem;
        position: absolute;
        background: #fff;
        width: 100%;
        z-index: 999;
        li {
          padding-top: 0.14rem;
        }
      }
    }
  }
  .nodata {
    width: 75%;
  }
  .data-edit-wrap {
    width: 100%;
  }
  .data-edit-wrap .data-edit-userinfo {
    padding: 0.2rem;
  }
  .data-edit-list li {
    font-size: 14px;
    line-height: 0.28rem;
    margin-top: 0.34rem;
  }
  .data-edit-list li p.edit-label {
    margin-right: 0.3rem;
  }
  .edit-btn {
    width: 2rem;
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 16px;
  }
  .data-edit-wrap .data-edit-userinfo .data-text {
    font-size: 14px;
  }
  .data-edit-wrap .data-edit-userinfo .data-text .data-nickname {
    font-size: 16px;
  }
  .data-edit-list li p .el-input__inner {
    height: 0.3rem;
    line-height: 0.3rem;
    font-size: 14px;
  }
  .data-edit-wrap .data-edit-userinfo .data-avatar {
    width: 0.9rem;
    height: 0.9rem;
    margin-right: 0.1rem;
  }
}
.el-radio {
  margin-right: 28px;
}
input[type="number"] {
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  -moz-appearance: textfield;
}
</style>